import {
  ADD_COMMENT,
  ADD_COMMENT_FAILURE,
  ADD_COMMENT_SUCCESS,
  //
  DELETE_COMMENT,
  DELETE_COMMENT_FAILURE,
  DELETE_COMMENT_SUCCESS,
  //
  EDIT_COMMENT,
  EDIT_COMMENT_FAILURE,
  EDIT_COMMENT_SUCCESS,
  //
  FETCH_COMMENTS,
  FETCH_COMMENTS_FAILURE,
  FETCH_COMMENTS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SET_COMMENT_FILTERS,
  TOGGLE_COMMENT_EDIT,
} from "./constants";

// List
export const fetchComments = (payload) => ({
  type: FETCH_COMMENTS,
  payload,
});
export const fetchCommentsSuccess = (payload) => ({
  type: FETCH_COMMENTS_SUCCESS,
  payload,
});
export const fetchCommentsFailure = (payload) => ({
  type: FETCH_COMMENTS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addComment = (payload, onAdd) => ({
  type: ADD_COMMENT,
  payload,
  onAdd,
});
export const addCommentSuccess = (payload) => ({
  type: ADD_COMMENT_SUCCESS,
  payload,
});
export const addCommentFailure = (payload) => ({
  type: ADD_COMMENT_FAILURE,
  payload,
});
// EDIT
export const editComment = (payload, onEdit) => ({
  type: EDIT_COMMENT,
  payload,
  onEdit,
});
export const editCommentSuccess = (payload) => ({
  type: EDIT_COMMENT_SUCCESS,
  payload,
});
export const editCommentFailure = (payload) => ({
  type: EDIT_COMMENT_FAILURE,
  payload,
});
// DELETE
export const deleteComment = (payload, onDelete) => ({
  type: DELETE_COMMENT,
  payload,
  onDelete,
});
export const deleteCommentSuccess = (payload) => ({
  type: DELETE_COMMENT_SUCCESS,
  payload,
});
export const deleteCommentFailure = (payload) => ({
  type: DELETE_COMMENT_FAILURE,
  payload,
});
// Set Filters
export const setCommentFilters = (payload) => ({
  type: SET_COMMENT_FILTERS,
  payload,
});
// Toggle Edit
export const toggleCommentEdit = (payload) => ({
  type: TOGGLE_COMMENT_EDIT,
  payload,
});
